<template>
<div class="p-grid">
<div class="p-col-12">
	<div class="card">
		<h5>Redirigiendo a TuMIDES</h5>
	</div>
</div>
</div>

</template>

<script>
import SmartService from '../service/SmartService';
export default {
	data() {
		return {
			code: this.$route.query['code'],
		}
    },
    smartService: null,
    created() {
         this.smartService = new SmartService();
    },	    
    mounted() {
		this.login();
    },
    methods: {
        login(){
			this.smartService.setAmbiente();
			if (this.code !== undefined){
				this.smartService.autenticarIDU(this.code).then(data => {        	
					if(data!=null) {
						if (data.LoginStatus==="OK"){
							localStorage.token = data.Token;
							localStorage.cedula = data.Documento;
							//CAMBIAR aquí se levanta el nivel del usuario
							/* localStorage.level = 1; */
							localStorage.level = data.Nivel;
							this.$router.replace({ name: "Datos personales" });
						} else {
							localStorage.tokenExt = data.Token;
							this.$router.replace({ name: "access" });
						}
					} else {
						console.log("persona is null");
						this.$router.replace({ name: "error" });
					}
				})
				.catch((e) => {
					console.log(e);
					this.$router.replace({ name: "error" });
					});
			}
			else {
				this.$router.replace({ name: "error" });
			}
		}
    }
};
</script>